// API base URL configuration
const stage = import.meta.env.VITE_STAGE || (import.meta.env.PROD ? 'prod' : 'dev');

const API_URLS: Record<string, string> = {
  dev: import.meta.env.VITE_API_URL || 'https://api.dev.yarntales.io/v1',
  prod: import.meta.env.VITE_API_URL || 'https://api.yarntales.io/v1',
};

export const apiConfig = {
  baseUrl: API_URLS[stage] || API_URLS.dev,
};
